import React, { useEffect, useRef, useState } from "react";
import { ICardProps } from "./types";
import { useReceiptCardInfo } from "./handlers/useReceiptCardInfo";
import tripService, { PaymentSessionResponse } from "../../api/trip.service";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EmbeddedKraken from "./EmbeddedKraken";

const RightCard: React.FC<ICardProps> = ({
  data,
  refetch,
  paymentCompleted,
}) => {
  const iframeId = "iframe-payment";
  const { i18n, t } = useTranslation("paymentPage");
  const lang = i18n.language === "zh" ? "zhHK" : "en";
  const { id } = useParams<{ id: string }>();
  const { total, status } = useReceiptCardInfo(data);
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentMethodsInView, setPaymentMethodsInView] = useState(false);
  const paymentMethodRef = useRef<HTMLDivElement>(null);

  const { data: paymentSession } = useQuery<PaymentSessionResponse, Error>(
    ["paymentSession", id],
    () => tripService.createPaymentSession(id!),
    {
      enabled: !!data && status === "PENDING_PAYMENT",
      retry: false,
    },
  );

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === "PAYMENT_METHODS_IN_VIEW") {
        console.log("Received PAYMENT_METHODS_IN_VIEW:", event.data.inView);
        setPaymentMethodsInView(!!event.data.inView);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const handleScrollToPayment = () => {
    document
      .querySelector(`iframe[id="${iframeId}"]`)
      ?.scrollIntoView({ behavior: "smooth" });
  };

  const handleOnPaymentSuccess = async () => {
    console.log("Payment Success!");
    setIsProcessing(true);
    if (refetch) {
      await refetch();
    }
  };

  useEffect(() => {
    const ref = paymentMethodRef.current;
    if (!ref) return;

    const observer = new window.IntersectionObserver(
      ([entry]) => {
        setPaymentMethodsInView(!!entry && entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0.1,
      },
    );

    observer.observe(ref);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (data && status !== "PENDING_PAYMENT" && id) {
      setIsProcessing(false);
      window.location.replace(`/web-receipt/${id}`);
    }
  }, [data, id]);

  if (!paymentSession) return <></>;

  return (
    <>
      <div
        className="
    bg-nobel-50 flex flex-col p-[16px] w-full
    rounded-b-lg mx-0
    md:rounded-lg md:mt-5 md:w-auto
  "
      >
        {/* {isProcessing && !paymentCompleted ? (
          <>
            <div className="flex flex-col items-center justify-center h-full w-full">
              <div className="mb-4">
                <span className="inline-block w-12 h-12 border-4 border-blue-400 border-t-transparent rounded-full animate-spin"></span>
              </div>
              <div className="text-lg font-semibold text-brand-blue">
                {t("processingPayment")}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="text-3xl font-bold text-mineshaft-900 leading-none mb-4 break-words">
              {t("confirmAndPay")}
            </div>
            <div className="border-b border-gray-200 rounded-lg bg-white p-[16px] flex flex-col items-start mb-1">
              <div className="text-base font-normal text-mineshaft-900 mb-2">
                {t("total")}
              </div>
              <div className="text-3xl font-bold text-mineshaft-900 leading-none mb-2 break-words">
                HK${total}
              </div>
              <div className="text-base font-normal text-mineshaft-900">
                {t("includesTaxesAndFees")}
              </div>
            </div>
          </>
        )} */}
        <>
          <div className="text-3xl font-bold text-mineshaft-900 leading-none mb-4 break-words">
            {t("confirmAndPay")}
          </div>
          <div className="border-b border-gray-200 rounded-lg bg-white p-[16px] flex flex-col items-start mb-1">
            <div className="text-base font-normal text-mineshaft-900 mb-2">
              {t("total")}
            </div>
            <div className="text-3xl font-bold text-mineshaft-900 leading-none mb-2 break-words">
              HK${total}
            </div>
            <div className="text-base font-normal text-mineshaft-900">
              {t("includesTaxesAndFees")}
            </div>
          </div>
        </>
        {paymentSession && (
          <EmbeddedKraken
            id={iframeId}
            paymentSession={paymentSession}
            // className="w-full mt-4 min-h-[60rem] mb-[5rem] border-none"
            onSuccess={handleOnPaymentSuccess}
            btnLocale={lang}
          />
        )}
        {!paymentMethodsInView && !isProcessing && !paymentCompleted && (
          <div className="fixed bottom-0 left-0 w-full bg-white p-4 z-50 md:hidden border-t border-gray-200">
            <button
              className="w-full bg-brand-blue text-white text-base font-semibold py-3 rounded-xl shadow"
              onClick={handleScrollToPayment}
            >
              {t("continueWithPayment")}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default RightCard;
